import { useLenis } from '@/hooks/useLenis';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import SurveyGrid from '@/components/SurveyGrid';
import { MaskedLine } from '@/components/Motion';

export default function Surveys() {
    useLenis();
    return (
        <div className="grain relative bg-sand-100 text-ink min-h-screen" data-testid="surveys-page">
            <Navbar />
            <main>
                <section className="pt-40 pb-4 max-w-[1600px] mx-auto px-6 md:px-12 lg:px-24">
                    <div className="flex items-center gap-3 text-[11px] uppercase tracking-[0.3em] mb-10 text-ink-600">
                        <span className="w-8 h-px bg-ink-600" />
                        <span>الدليل الكامل</span>
                    </div>
                    <h1 className="font-display font-black text-[12vw] md:text-[7vw] leading-[1] tracking-tight">
                        <span className="block">
                            <MaskedLine delay={0.2}>تصفّح</MaskedLine>
                        </span>
                        <span className="block italic font-light text-emerald-signal">
                            <MaskedLine delay={0.4}>الاستطلاعات</MaskedLine>
                        </span>
                    </h1>
                </section>
                <SurveyGrid />
            </main>
            <Footer />
        </div>
    );
}
